import {

  getterNames,
  API_GET_NOTIFICATIONS,
  API_POST_NOTIFICATION,
  API_PUT_NOTIFICATION,
  API_DELETE_NOTIFICATION,
  API_PUT_STATUS_NOTIFICATION,
} from './types';

import { buildApiRequest } from '@/modules/Vuex';

import {
  notificationsAdd as apiNotificationsAdd,
  listOfNotifications as apiListOfNotifications,
  notificationsUpdate as apiNotificationsUpdate,
  notificationsDelete as apiNotificationsDelete,
  notificationsChangeStatus as apiNotificationsChangeStatus,
} from '@/api/routes/notifications';

const state = {
};
const getters = {
  [getterNames.NOTIFICATIONS_GET_NOTIFICATIONS]:
    state => state.get_notifications?.response?.data?.data,
  [getterNames.NOTIFICATIONS_GET_NOTIFICATIONS_FETCHING]:
    state => state.get_notifications?.isFetching,
  [getterNames.NOTIFICATIONS_POST_NOTIFICATION_FETCHING]:
    state => state.post_notification?.isFetching,
  [getterNames.NOTIFICATIONS_PUT_NOTIFICATION_FETCHING]:
    state => state.put_notification?.isFetching,
  [getterNames.NOTIFICATIONS_DELETE_NOTIFICATION_FETCHING]:
    state => state.delete_notification?.isFetching,
};
const mutations = {};
const actions = {};

const notificationsModule = {
  state,
  getters,
  mutations,
  actions,
};

buildApiRequest({
  storeModule: notificationsModule,
  actionTypes: API_GET_NOTIFICATIONS,
  apiRoute: apiListOfNotifications,
});

buildApiRequest({
  storeModule: notificationsModule,
  actionTypes: API_POST_NOTIFICATION,
  apiRoute: apiNotificationsAdd,
});

buildApiRequest({
  storeModule: notificationsModule,
  actionTypes: API_DELETE_NOTIFICATION,
  apiRoute: apiNotificationsDelete,
});

buildApiRequest({
  storeModule: notificationsModule,
  actionTypes: API_PUT_NOTIFICATION,
  apiRoute: apiNotificationsUpdate,
});

buildApiRequest({
  storeModule: notificationsModule,
  actionTypes: API_PUT_STATUS_NOTIFICATION,
  apiRoute: apiNotificationsChangeStatus,
});

export default notificationsModule;
